// Promoted to the `pict-section-tabbar` library. This shim keeps the existing app imports
// (require('./TabBar.js') / require('../views/TabBar.js')) working unchanged; new code should
// require the library directly. See source/pict-section-tabbar/.
module.exports = require('pict-section-tabbar');
